import { Component, HostListener, Inject, OnInit, Optional } from '@angular/core';
import { Audit } from '../shared/models/audit';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Form, FormBuilder, FormGroup } from '@angular/forms';
import { PaymentResponseDto } from '../shared/models/paymentResponseDto';
import { ExpectFundResponseDto } from '../shared/models/expectResponseDto'
import { AttachmentData, RequestDocAttachmentResponse, RequestDocAttachmentDto } from '../shared/models/requestDocAttachment';
import { RequestsService } from '../shared/services/requests.service';
import { JournalResponseDto } from '../shared/models/journalResponseDto';
import { TransferFundResponseDto } from '../shared/models/transferFundResponseDto';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { AuditService } from '../shared/services/audit.service';
import { RequestType, RequestTypeOrder } from '../enums/request-type.enum';
import { RpaStatus } from '../enums/rpa-status.enum';
@Component({
    selector: 'xp-view-audit',
    templateUrl: './view-audit.component.html',
    styleUrl: './view-audit.component.scss'
})
export class ViewAuditComponent implements OnInit {
    RequestType = RequestType;
    dialogData: Audit;
    form!: FormGroup;
    paymentData!: PaymentResponseDto;
    receiptData!: ExpectFundResponseDto;
    journalData!: JournalResponseDto;
    transferData!: TransferFundResponseDto;
    fileNames: AttachmentData[] = [];
    fileToBeDownloaded!: RequestDocAttachmentResponse;
    displayFile: string[] = [];
    disableUpload: Boolean = false;
    disableButtons: Boolean = false;
    attachments: RequestDocAttachmentDto[] = [];
    isDialogOpen = false;

    constructor(@Optional() @Inject(MAT_DIALOG_DATA) public data: Audit, private formBuilder: FormBuilder,
        private requestService: RequestsService, private router: Router, private route: ActivatedRoute,
        private auditService: AuditService) {
        this.dialogData = data;

        this.isDialogOpen = !!data;

        this.form = this.formBuilder.group({
            requestId: '',
            requestType: '',
            stage: '',
            updatedDate: '',
            updatedBy: '',
            amount: '',
            matterNumber: '',
            matterName: [''],
            matterFrom: '',
            matterTo: '',
            clientName: [''],
            approvalStatus: '',
            rejectedReason: '',
            wasRpaSuccessfull: '',
            failureReason: '',
            transactionDate: '',
            transactionTime:'',
            uploadedFiles: [[]]
        });

    }

    ngOnInit() {
        if (!this.data) {

            const type = this.route.snapshot.paramMap.get('type');
            const id = Number(this.route.snapshot.paramMap.get('id'));

            if (id && type) {
                this.auditService.getUserAuditByRequest(id, RequestTypeOrder[type as RequestType])
                    .then((res: Audit[]) => {
                        if (res && res.length > 0) {
                            this.data = res[0];
                            this.loadData(this.data);
                        }
                    });
            }
            return;
        }

        this.loadData(this.data);

        if (this.form.get('uploadedFiles')?.value.length == 0) {
            this.disableUpload = true;
        }
    }


    private loadData(audit: Audit) {
        if (!audit) return;

        this.form.patchValue({
            requestId: audit.requestId,
            requestType: audit.requestTypeName,
            stage: audit.stageName,
            updatedDate: audit.updatedDate,
            updatedBy: audit.updatedByName,
            amount: audit.amount,
            matterNumber: audit.matterNo,
            approvalStatus: audit.approvalStatus,
            rejectedReason: audit.rejectedReason,
        });

        switch (audit.requestTypeName) {
            case RequestType.Payment:
                this.requestService.getPaymentRequestById(audit.requestId)
                    .then(res => {
                        this.paymentData = res;
                        this.attachments = res.documents ?? [];
                        this.form.patchValue({ wasRpaSuccessfull: res.rpaStatus });
                        this.form.patchValue({ failureReason: res.rpaFailureReason });
                        this.form.patchValue({ clientName: res.clientName });
                        this.form.patchValue({ matterName: res.matter });
                        this.form.patchValue({ transactionDate: res.dateTransaction });
                        if (res.dateTransaction) {
                            const d = new Date(res.dateTransaction);
                            this.form.get('transactionTime')?.setValue(this.toTimeString(d));
                        }
                    });
                break;

            case RequestType.ExpectFunds:
                this.requestService.GetExpectFundBasedOnId(audit.requestId)
                    .then(res => {
                        this.receiptData = res;
                        this.attachments = res.documents ?? [];
                        this.form.patchValue({ wasRpaSuccessfull: res.rpaStatus });
                        this.form.patchValue({ failureReason: res.rpaFailureReason });
                        this.form.patchValue({ clientName: res.clientName });
                        this.form.patchValue({ matterName: res.matter });
                        this.form.patchValue({ transactionDate: res.dateTransaction });
                        if (res.dateTransaction) {
                            const d = new Date(res.dateTransaction);
                            this.form.get('transactionTime')?.setValue(this.toTimeString(d));
                        }
                    });
                break;

            case RequestType.Journal:
                this.requestService.GetJournalRequestBasedOnId(audit.requestId)
                    .then(res => {
                        this.journalData = res;
                        this.attachments = res.documents ?? [];
                        this.form.patchValue({ wasRpaSuccessfull: res.rpaStatus });
                        this.form.patchValue({ failureReason: res.rpaFailureReason });
                        this.form.patchValue({ matterFrom: res.matterFrom });
                        this.form.patchValue({ matterTo: res.matterTo });
                        this.form.patchValue({ transactionDate: res.dateTransaction });
                        if (res.dateTransaction) {
                            const d = new Date(res.dateTransaction);
                            this.form.get('transactionTime')?.setValue(this.toTimeString(d));
                        }
                    });
                break;

            case RequestType.TransferFund:
                this.requestService.GetTransferFundbyId(audit.requestId)
                    .then(res => {
                        this.transferData = res;
                        this.form.patchValue({ wasRpaSuccessfull: res.rpaStatus });
                        this.form.patchValue({ failureReason: res.rpaFailureReason });
                        this.form.patchValue({ clientName: res.client });
                        this.form.patchValue({ matterName: res.matter });
                        this.form.patchValue({ transactionDate: res.dateTransaction });
                        if (res.dateTransaction) {
                            const d = new Date(res.dateTransaction);
                            this.form.get('transactionTime')?.setValue(this.toTimeString(d));
                        }
                    });
                break;
        }
    }


    openInNewTab() {
        const type = this.dialogData.requestTypeName;
        const id = this.dialogData.requestId;

        const url = this.router.serializeUrl(
            this.router.createUrlTree([`/audit/${type}/${id}`])
        );

        window.open(url, '_blank');
    }

    get requestInfo(): { requestId?: number; requestType?: string } {
        return {
            requestId: this.data?.requestId,
            requestType: this.data?.requestTypeName
        };
    }

    get showFailureReason(): boolean {
        return this.form.get('wasRpaSuccessfull')?.value === RpaStatus.Failed;
    }

    get hasAttachments(): boolean {
        return this.attachments?.length > 0;
    }

    downloadDocuments(requestId: number, requestType: string) {
        this.requestService.getRequestDocumentList(requestId, requestType).then((res) => {
            this.fileToBeDownloaded = res;
            this.downloadMultipleBase64Files(this.fileToBeDownloaded.attachments ?? [])
        });
    }

    downloadMultipleBase64Files(files: AttachmentData[]): void {
        files.forEach(file => {
            const { attachments, fileName } = file;
            const byteCharacters = atob(attachments);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray], { type: 'application/octet-stream' });
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = fileName;
            link.click();
        });
    }
    previewFile(file: AttachmentData) {
        const byteCharacters = atob(file.attachments);
        const byteNumbers = Array.from({ length: byteCharacters.length }, (_, i) => byteCharacters.charCodeAt(i));
        const blob = new Blob([new Uint8Array(byteNumbers)], { type: 'application/octet-stream' });
        const url = URL.createObjectURL(blob);

        window.open(url, '_blank');
    }

    private toTimeString(date: Date): string {
        const pad = (n: number) => String(n).padStart(2, '0');
        return `${pad(date.getHours())}:${pad(date.getMinutes())}`;
    }
}
